var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background{background-image:url(" + escape(require("../../assets/images/estera_separadora_entulho_geresol_P-10G.jpg")) + ");background-color:#000000;background-size:cover;background-position:center;background-blend-mode:luminosity;margin-left:7%;border:5px solid #f8f9fa;margin-top:-7px;opacity:0.5;z-index:-1}\n", ""]);

// exports
